import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { isWholesaleModeVar } from '../../apolloClient'
interface Props {
  hide?: boolean
}
const WholesaleMode: React.FC<Props> = ({ hide, children }) => {
  const isWholesaleMode = useReactiveVar(isWholesaleModeVar)
  if (isWholesaleMode && !hide) return <>{children}</>
  if (isWholesaleMode && hide) return null
  if (!isWholesaleMode && !hide) return null
  return <>{children}</>
}

export default WholesaleMode
